import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './fr.json';
import { SUPPORT_EMAIL, SUPPORT_PHONE } from '../constants/supportContact';

// Arabe retiré du bundle (arbitrage Alfred 2026-08-02, audit bilinguisme) :
// 58 clés traduites sur 2 269 et aucun sélecteur ne l'exposait. Un ancien
// choix « ar » persisté en localStorage retombe proprement sur le français.
const stored = localStorage.getItem('rectorium_lang');
const savedLang = stored === 'en' ? 'en' : 'fr';

/*
 * Français embarqué, anglais chargé à la demande (audit 2026-08-16).
 *
 * Les deux dictionnaires pèsent 1 063 ko et 999 ko : les embarquer tous les
 * deux mettait 2 Mo de traductions dans le fragment initial, dont la moitié
 * n'est jamais lue par un utilisateur donné. C'était l'essentiel des 1,73 Mo
 * du fragment principal — le découpage des dépendances tierces, déjà complet,
 * ne pouvait rien y faire.
 *
 * Le français reste synchrone parce qu'il est la langue de repli : il doit
 * être présent au tout premier rendu, sinon l'écran s'affiche avec des clés
 * brutes le temps d'un aller-retour réseau. L'anglais, lui, arrive en différé
 * — et tant qu'il n'est pas là, i18next sert le français plutôt que la clé.
 */
i18n
  .use(initReactI18next)
  .init({
    resources: { fr: { translation: fr } },
    lng: savedLang,
    fallbackLng: 'fr',
    // `school_head` : intitulé du chef d'école (Doyen / Directeur d'école…), remplacé
    // par le réglage du tenant dans services/tenantTerms.js.
    // `support_email` / `support_phone` : le canal de support de Rectorium Corporation, une seule source
    // (constants/supportContact.js). `devise` et `tenant_city` sont posées par services/tenantTerms.js.
    interpolation: {
      escapeValue: false,
      defaultVariables: {
        school_head: savedLang === 'en' ? 'Dean' : 'Doyen',
        support_email: SUPPORT_EMAIL,
        support_phone: SUPPORT_PHONE,
      },
    },
    returnObjects: true,
  });

if (savedLang === 'en') {
  import('./en.json')
    .then(({ default: en }) => {
      i18n.addResourceBundle('en', 'translation', en, true, true);
      // Force le re-rendu des composants déjà montés avec le repli français.
      i18n.changeLanguage('en');
    })
    .catch(() => {
      // Chargement impossible (réseau) : l'application reste en français,
      // entièrement lisible. On ne bloque jamais l'écran pour une traduction.
    });
}

/**
 * Bascule de langue — charge le dictionnaire s'il n'est pas encore là.
 * À utiliser partout à la place d'un `i18n.changeLanguage()` direct : sans le
 * chargement préalable, passer en anglais n'afficherait que du français.
 */
export async function changerLangue(langue) {
  const cible = langue === 'en' ? 'en' : 'fr';
  if (cible === 'en' && !i18n.hasResourceBundle('en', 'translation')) {
    try {
      const { default: en } = await import('./en.json');
      i18n.addResourceBundle('en', 'translation', en, true, true);
    } catch {
      return false; // dictionnaire indisponible : on reste sur la langue courante
    }
  }
  await i18n.changeLanguage(cible);
  try { localStorage.setItem('rectorium_lang', cible); } catch { /* stockage refusé */ }
  document.documentElement.lang = cible;
  return true;
}

document.documentElement.lang = savedLang;
document.documentElement.dir = 'ltr';

export default i18n;
